// extracted by mini-css-extract-plugin
export default {"switch":"ToggleSmall_switch__SGZq9","slider":"ToggleSmall_slider__qJ+2C","round":"ToggleSmall_round__TSNb-"};